import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import * as pbi from 'powerbi-client';
import { EmbeddedToken } from '../embeddedToken.model';
import { PowerBiReport } from '../power-bi-report.model';
import { PowerBiReportService } from '../services/power-bi-report.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-power-bi-report',
  templateUrl: './power-bi-report.component.html',
  styleUrls: ['./power-bi-report.component.scss']
})
export class PowerBiReportComponent implements OnInit, OnChanges {

  @Input()
  reportId: string;

  @ViewChild('power') power: ElementRef;

  private powerbi;

  constructor(private powerBiReportService: PowerBiReportService,
              private toastrService: ToastrService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.refreshDashboard();
  }

  refreshDashboard() {
    this.powerBiReportService.getPowerBiReportById(this.reportId).toPromise()
      .then((powerBiReport: PowerBiReport) => {
        this.powerBiReportService.getReportToken(this.reportId)
          .subscribe(
            (embeddedToken: EmbeddedToken) => {
              const embedConfiguration = {
                type: 'report',
                id: powerBiReport.id,
                embedUrl: powerBiReport.embedUrl + '&filterPaneEnabled=false',
                tokenType: pbi.models.TokenType.Embed,
                accessToken: embeddedToken.token
              };
              this.powerbi.embed(this.power.nativeElement, embedConfiguration)
            }, (error: HttpErrorResponse) => {
              console.log(error);
              this.toastrService.error(error.error.message || this.translate.instant('power-bi.errors.fetch'));
            });

      }).catch((error: HttpErrorResponse) => {
        console.log(error);
        this.toastrService.error(error.error.message || this.translate.instant('power-bi.errors.fetch'));
    });
  }

}
